import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { keys } from './keys'
import { fetchOpeningSessions, type FetchOpeningSessionsParams } from './opening-sessions.queries'

export const getOpeningSessionsOptions = (params?: FetchOpeningSessionsParams) =>
  queryOptions({
    queryKey: keys.openingSessions.list(params),
    queryFn: () => fetchOpeningSessions(params),
    placeholderData: keepPreviousData,
  })
